import React from 'react';
import { connect } from 'react-redux';

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';

import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Divider,
	Form,
	Input,
	Radio,
	DatePicker,
	InputNumber,
	TreeSelect,
	Select
} from 'antd';

import { fetchAnnualLeaveList, updateAnnualLeave } from '../../actions/attendance-actions.js';
import annualLeaveService from '../../services/Attendance/annual-leave-service';
import moment from 'moment';

const { TreeNode } = TreeSelect;
const Option = Select.Option;

class AnnualLeave extends React.Component {
	state = {
		exportModalStatus: false,
		currentModalStatus: false,
		loading: false,
		filters: {
			real_name: null,
			department_id: null,
			job_status: null,
		},
		data: null
	}

	componentWillMount() {
		this.props.fetchDepartmentsList();
		//this.props.fetchAnnualLeaveList();
		this.fetchFilterData(1);
	}

	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}

	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode value={`${item.id}`} title={item.name} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}
	setDepartmentFilter = value => {
		this.setState({
			filters: { ...this.state.filters, department_id: value }
		});
	}

	setStatusFilter = event => {
		let status = event.target.value === '-1' ? null : event.target.value;
		this.setState({
			filters: { ...this.state.filters, job_status: status }
		}
			// , () => {
			// 	this.fetchFilterData(1);
			// }
		);
	}

	setRealNameFilter = event => {
		this.setState({
			filters: { ...this.state.filters, real_name: event.target.value }
		});
	}
	setStartDateFilter = value => {
		this.setState({
			filters: { ...this.state.filters, start_date: value }
		});
	}
	setEndDateFilter = value => {
		this.setState({
			filters: { ...this.state.filters, end_date: value }
		});
	}
	setYearFilter = year => {
		let gets = {
			...this.state.filters,
			year: year
		}
		this.setState({
			filters: gets
		})
		// Object.keys(gets).forEach(key => {
		// 	if (null === gets[key]) {
		// 		delete gets[key];
		// 	}
		// });
		// this.props.fetchAnnualLeaveList(gets);

	}

	fetchPageFilter = pagination => {
		this.fetchFilterData(pagination.current);
	}

	fetchFilterData = page => {
		this.setState({ loading: true })
		let gets = {
			...this.state.filters,
			page: page
		}
		//this.props.fetchAnnualLeaveList(gets);
		annualLeaveService.fetchAnnualLeaveList(gets, res => {
			if (res.data) {
				this.setState({ data: res.data })
			}
			this.setState({ loading: false })
		})
	}

	updateCurrent = index => {
		this.setState({ currentModalStatus: true });
		this.setState({ currentIndex: index });
		this.setState({ currentData: this.state.data.Data[index] });
	}

	exportAction = () => {
		let ref = Modal.info({ content: "正在准备需要下载的文件, 请注意下载文件可能被浏览器阻挡" });

		annualLeaveService.exportAnnualLeaveList({ ...this.state.filters }, res => {
			ref.destroy();
			if (200 === res.status && res.data.Success) {
				window.open(res.data.Message);
			} else {
				message.error('导出失败, ' + res.data.Errors[0], 4);
			}
		});
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
	}

	submitCurrentData = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let puts = {
					...this.state.currentData,
					...values,
				}
				this.setState({ currentModalStatus: false });
				annualLeaveService.updateAnnualLeave(puts, (res) => {
					if (res.data.Success) {
						message.success("修改成功", 4)
						this.fetchFilterData(this.state.filters.page);
					} else {
						message.error(res.data.Message);
					}
				})
			}
		})
	}

	reCaculate = () => annualLeaveService.reCaculate(res => {
		if (res.data.Success) {
			message.success("年假重算额度成功", 4)
		} else {
			message.error("年假重算额度失败，" + res.data.Errors[0], 4)
		}
	}, err => message.error("年假重算额度失败", 4))

	render() {
		const columns = [

			{ title: '工号', dataIndex: 'job_number', className: 'certificate-head-class' },

			{
				title: '中文名',
				dataIndex: 'real_name',
				key: 'real_name',
				className: "table-global-head-short"
			},

			{
				title: '英文名',
				dataIndex: 'english_name',
				key: 'english_name',
				className: "table-global-head"
			},


			{
				title: '部门',
				dataIndex: 'department_name',
				key: 'department_name',
				className: "table-global-head"
			},

			{
				title: '年份',
				dataIndex: 'year',
				key: 'year',
				className: "table-global-head-short"
			},
			{
				title: '今年总额度',
				dataIndex: 'this_year_total_amount',
				key: 'this_year_total_amount',
				className: "table-global-head-short"
			},
			{
				title: '今年已休天数',
				dataIndex: 'this_year_used_amount',
				key: 'this_year_used_amount',
				className: "table-global-head-short"
			},
			{
				title: '当前可用天数',
				dataIndex: 'current_can_use_amount',
				key: 'current_can_use_amount',
				className: "table-global-head-short"
			},
			{
				title: '待审批天数',
				dataIndex: 'pending_amount',
				key: 'pending_amount',
				className: "table-global-head-short"
			},
			{
				title: '去年结余天数',
				dataIndex: 'last_year_left_amount',
				key: 'last_year_left_amount',
				className: "table-global-head-short"
			},
			{
				title: '即将过期天数(四月之前)',
				dataIndex: 'need_invalid_amount',
				key: 'need_invalid_amount',
				className: "table-global-head-short"
			},

			{
				title: '操作',
				dataIndex: 'action',
				key: 'action',
				className: "table-global-head-small",
				render: (text, record, index) => {
					return this.props.access.annualLleave.u_value &&
						<Button icon="edit" size="small" className="row-action-btn"
							onClick={this.updateCurrent.bind(this, index)}>编辑</Button>
				}
			}
		];
		return (
			<div className="app-module-item">
				{/* <div className="colAction" style={{float:"left"}}>
					{this.props.access.annualLleave.export_value && 
					<Button type="primary" onClick={this.exportAction}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>}
					<Divider type="vertical" />
					{this.props.access.annualLleave.recalculate_value && <Button type="primary" onClick={this.reCaculate}>
						<Icon type="reload" />
						<span>重算额度</span>
					</Button>}
				</div> */}
				<div className="colAction" style={{ float: "left", marginRight: "10px" }} >
					<Button icon={"cloud-download-o"}
						type={"primary"}
						size={"default"}
						onClick={this.exportAction} >
						<span>{"导出"}</span>
					</Button>
				</div>
				<div className="colAction" style={{ float: "right" }}>
					<Input placeholder="请输入用户姓名或工号" style={{ width: "200px", marginRight: "15px", marginBottom: "20px" }}
						value={this.state.filters.real_name} onChange={this.setRealNameFilter} />
					<span style={{ marginRight: "15px", marginBottom: "20px" }}>
						{this.props.departmentStructure.departmentsList ?
							<TreeSelect style={{ width: 230 }}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								placeholder="根据部门选择"
								allowClear
								treeDefaultExpandAll
								onChange={this.setDepartmentFilter} >
								{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
							</TreeSelect> :
							<Spin />
						}
					</span>
					<Button type="primary" style={{ marginRight: "15px" }} onClick={this.fetchFilterData.bind(this, 1)}>
						<span>查询</span>
					</Button>
					<Radio.Group defaultValue="-1" onChange={this.setStatusFilter}>
						<Radio.Button value="-1">全部</Radio.Button>
						<Radio.Button value="1">在职</Radio.Button>
						<Radio.Button value="2">离职</Radio.Button>
					</Radio.Group>
				</div>
				<div className="colAction" style={{ float: "right", marginRight: "10px" }} >

					<Select style={{ width: 120 }} placeholder="请选择年份" onChange={this.setYearFilter}>

						<Option value="2019">2019</Option>
						<Option value="2020">2020</Option>
						<Option value="2021">2021</Option>
						<Option value="2022">2022</Option>
					</Select>
				</div>


				<div style={{ clear: "both" }}></div>
				{this.state.data ?
					<Table columns={columns}
						loading={this.state.loading}
						dataSource={this.state.data.Data}
						rowKey={record => record.id}
						scroll={{ x: 800 }}
						pagination={{
							total: this.state.data.Total,
							defaultCurrent: 1,
							pageSize: this.state.data.PageSize,
							current: this.state.data.Page
						}}
						onChange={this.fetchPageFilter} /> : (
						<div style={{ textAlign: 'center', margin: '100px 0px' }}>
							<Spin size="large" />
						</div>)
				}
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="年假"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentData}>
					<div style={{ textAlign: "center", margin: "0px 0px 5px", overflowY: "auto" }}>
						{this.state.currentData &&
							<Form onSubmit={this.submitCurrentData} className="login-form" layout="inline">
								<div>
									<Form.Item label="员工姓名" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('real_name', {
											rules: [],
											initialValue: this.state.currentData.real_name
										})(<Input disabled placeholder={1} style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								<div>
									<Form.Item label="所在部门" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('department_name', {
											rules: [],
											initialValue: this.state.currentData.department_name
										})(<Input disabled placeholder={1} style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								<div>
									<Form.Item label="工号" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('job_number', {
											rules: [],
											initialValue: this.state.currentData.job_number
										})(<Input disabled placeholder={1} style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								{/* <div>
									<Form.Item label="入职工龄(年)" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('working_years', {
											rules: [],
											initialValue: this.state.currentData.working_years
										})(<Input disabled placeholder={1} style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div> */}
								<div style={{ marginLeft: "9px" }}>
									<Form.Item label="今年总额度(天)" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('this_year_total_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.this_year_total_amount
										})(<InputNumber style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								<div style={{ marginLeft: "9px" }}>
									<Form.Item label="今年已休天数(天)" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('this_year_used_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.this_year_used_amount
										})(<InputNumber style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								{/* <div style={{ marginLeft: "9px" }}>
									<Form.Item label="去年结余" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('last_year_left_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.last_year_left_amount
										})(<InputNumber style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div> */}
								<div style={{ marginLeft: "9px" }}>
									<Form.Item label="当前可用" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('current_can_use_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.current_can_use_amount
										})(<InputNumber disabled style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
								{/* <div style={{ marginLeft: "9px" }}>
									<Form.Item label="剩余可用" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('this_year_left_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.this_year_left_amount
										})(<InputNumber style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div> */}

								<div style={{ marginLeft: "9px" }}>
									<Form.Item label="即将过期" className='AttendanceSchedule'>
										{this.props.form.getFieldDecorator('need_invalid_amount', {
											rules: [{ required: true }],
											initialValue: this.state.currentData.need_invalid_amount
										})(<InputNumber disabled style={{ width: "300px", color: "black" }} />)}
									</Form.Item>
								</div>
							</Form>}
					</div>
				</Modal>
			</div>
		);
	}
}
const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure,
		attendance: state.attendance,
		user: state.user
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList,
	fetchAnnualLeaveList,
	updateAnnualLeave
}

AnnualLeave = Form.create()(AnnualLeave);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AnnualLeave));




// WEBPACK FOOTER //
// ./src/routes/Attendance/AnnualLeave.js